import { createContext, useContext } from "react";

export type FlyoutPostContentEntry = {
  body: string;
  media: string;
};

export type FlyoutPostContextState = {
  assets: FlyoutPostContentEntry[];
  idxAsset: number;
  incrementAssetIdx: () => void;
  decrementAssetIdx: () => void;
};

export const defaultFlyoutPostContextState: FlyoutPostContextState = {
  assets: [],
  idxAsset: 0,
  incrementAssetIdx: () => {},
  decrementAssetIdx: () => {},
};

export const FlyoutPostStateContext = createContext<FlyoutPostContextState>(
  defaultFlyoutPostContextState,
);
export const useFlyoutPostState = () => useContext(FlyoutPostStateContext);
